import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { API } from 'network/api';
import { FarmerGroupPayload } from 'types/request';
import { handleAxiosError } from 'utils/helpers';

type MutationConfig = {
  onError?: () => void;
  onSuccess?: () => void;
  onFinish?: () => void;
  method?: 'POST' | 'PUT';
};

const useMutateFarmerGroup = (config?: MutationConfig) => {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (data: FarmerGroupPayload) =>
      API.request({
        url: `/cubes/${config?.method === 'PUT' && data.id ? data.id : ''}`,
        data,
        method: config?.method ?? 'POST',
      }),
    onSuccess: () => {
      config?.onSuccess?.();
      queryClient.invalidateQueries({
        queryKey: ['farmer-group', 'farmer-group-leader', 'farmer-group-by-id'],
      });
      message.success(
        config?.method === 'POST'
          ? 'Farmer Group successfully submitted.'
          : 'Farmer Group changes have been saved successfully.',
      );
    },
    onError: (error) => {
      config?.onError?.();
      handleAxiosError(
        error,
        config?.method === 'POST'
          ? 'Failed to create Farmer Group. Please try again'
          : 'Failed to save changes to the Farmer Group. Please try again.',
      );
    },
    onSettled: () => {
      config?.onFinish?.();
    },
  });

  return mutation;
};

export default useMutateFarmerGroup;
